module.exports = __webpack_public_path__ + "img/finder-iconsa5d4.23e19f1.svg";